module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block-content",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "font-size-lg text-black mb-5"
  }, [_vm._v("\r\n                " + _vm._s(_vm.order.billing_person)), _c('br'), _vm._v(" "), (_vm.order.billing_company) ? _c('small', [_vm._v(_vm._s(_vm.order.billing_company))]) : _vm._e()]), _vm._v(" "), _c('address', [_vm._v("\r\n                " + _vm._s(_vm.order.billing_address)), _c('br'), _vm._v("\r\n                " + _vm._s(_vm.order.billing_postal_code) + " " + _vm._s(_vm.order.billing_city)), _c('br'), _c('br'), _vm._v(" "), (_vm.order.billing_phone) ? _c('span', [_c('i', {
    staticClass: "fa fa-phone mr-5"
  }), _vm._v(" " + _vm._s(_vm.order.billing_phone)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.order.billing_email) ? _c('span', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o mr-5"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.order.billing_email))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "block-content",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "font-size-lg text-black mb-5"
  }, [_vm._v("\r\n                " + _vm._s(_vm.order.shipping_person)), _c('br'), _vm._v(" "), (_vm.order.shipping_company) ? _c('small', [_vm._v(_vm._s(_vm.order.shipping_company))]) : _vm._e()]), _vm._v(" "), _c('address', [_vm._v("\r\n                " + _vm._s(_vm.order.shipping_address)), _c('br'), _vm._v("\r\n                " + _vm._s(_vm.order.shipping_postal_code) + " " + _vm._s(_vm.order.shipping_city)), _c('br'), _c('br'), _vm._v(" "), (_vm.order.shipping_phone) ? _c('span', [_c('i', {
    staticClass: "fa fa-phone mr-5"
  }), _vm._v(" " + _vm._s(_vm.order.shipping_phone)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.order.shipping_email) ? _c('span', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o mr-5"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.order.shipping_email))])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Betaaladres")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Verzendadres")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe838bd4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/orders/OrderAddress.vue
// module id = 766
// module chunks = 1